import worldConfig from "@/config/world.config";
var X_MIN = 100;
var X_MAX = worldConfig.dimension.boundary.width - 200;
var Y_MIN = 100;
var Y_MAX = worldConfig.dimension.boundary.height - 200;
var rnd = function (min, max) {
    return Math.trunc(Math.random() * (max - min) + min);
};
var run = function () { return ({
    x: rnd(X_MIN, X_MAX),
    y: rnd(Y_MIN, Y_MAX),
    angle: 0,
}); };
var PositionHelper = {
    run: run,
};
export default PositionHelper;
